module.exports = __webpack_public_path__ + "img/coupon_tutorial_imymerry03.37db55be.png";